import { render } from "./SetsDeadlineDialog.vue?vue&type=template&id=5f57f9bb"
import script from "./SetsDeadlineDialog.vue?vue&type=script&lang=js"
export * from "./SetsDeadlineDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__